import z from "zod";

/**
 * Shared constants for app name validation
 */
export const APP_NAME_SLUG_MIN_LENGTH = 3;
export const APP_NAME_SLUG_MAX_LENGTH_WITHOUT_SUFFIX = 23;
export const APP_NAME_SLUG_MAX_LENGTH_WITH_SUFFIX = 30;
export const APP_NAME_SLUG_REGEX = /^[a-z0-9-]+$/;

/**
 * Schema for app names generated by AI (without suffix)
 */
export const AppNameGenerationSchema = z.object({
  displayName: z
    .string()
    .describe(
      "A human-readable name for the app (can include spaces and capitals)",
    ),
  slug: z
    .string()
    .regex(
      APP_NAME_SLUG_REGEX,
      "Must be lowercase alphanumeric with hyphens only",
    )
    .min(APP_NAME_SLUG_MIN_LENGTH)
    .max(APP_NAME_SLUG_MAX_LENGTH_WITHOUT_SUFFIX)
    .describe(
      `URL-safe slug for the app (lowercase, alphanumeric, hyphens only, ${APP_NAME_SLUG_MIN_LENGTH}-${APP_NAME_SLUG_MAX_LENGTH_WITHOUT_SUFFIX} characters)`,
    ),
});

/**
 * Schema for validating final app slugs (with suffix)
 */
export const AppNameSlugSchema = z
  .string()
  .regex(
    APP_NAME_SLUG_REGEX,
    "Must be lowercase alphanumeric with hyphens only",
  )
  .min(APP_NAME_SLUG_MIN_LENGTH)
  .max(APP_NAME_SLUG_MAX_LENGTH_WITH_SUFFIX);

/**
 * Validates an app slug
 */
export function validateAppSlug(slug: string): boolean {
  return AppNameSlugSchema.safeParse(slug).success;
}
